// extracted by mini-css-extract-plugin
module.exports = {"text":"rulesDialog_text__cZj16","nothing":"rulesDialog_nothing__BPlD6"};